namespace Matrix.Data {
    export class TestResultColumns {
        static columnsKey = 'Data.TestResult';
    }
}
